import { FormControl } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import CustomInput from 'src/components/CustomInput';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { ErrorMessage } from 'src/components/ErrorMessage';
import { FieldLabel } from 'src/components/FieldLabel';

import useStyles from './useStyles';

export const FieldInput = ({
  className,
  classes,
  label,
  error,
  placeholder,
  description,
  value,
  onChange,
  disallowLogRocket,
  type,
  autoFocus,
  hideErrorMessage,
  LabelProps,
  InputProps,
  ...restProps
}) => {
  const styles = useStyles({ classes });

  return (
    <FormControl
      className={cx(styles.root, className)}
      {...restProps}
    >
      {label && (
        <div className={styles.header}>
          <FieldLabel
            label={label}
            {...LabelProps}
          />
        </div>
      )}

      <CustomInput
        className={styles.input}
        dataTestId={label.toLowerCase()}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        error={Boolean(error)}
        autoFocus={autoFocus}
        disallowLogRocket={disallowLogRocket}
        type={type}
        {...InputProps}
      />

      {!hideErrorMessage && (
        <ErrorMessage
          className={styles.error}
          error={error}
        />
      )}

      {description && (
        <CustomTypography
          className={styles.description}
          variant={TYPOGRAPHY_VARIANT.paragraph12}
        >
          {description}
        </CustomTypography>
      )}
    </FormControl>
  );
};

FieldInput.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  error: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  disallowLogRocket: PropTypes.bool,
  type: PropTypes.string,
  autoFocus: PropTypes.bool,
  hideErrorMessage: PropTypes.bool,
  LabelProps: PropTypes.shape({}),
  InputProps: PropTypes.shape({}),
};

FieldInput.defaultProps = {
  className: null,
  classes: null,
  label: '',
  error: null,
  placeholder: '',
  description: '',
  onChange: null,
  disallowLogRocket: false,
  type: '',
  autoFocus: false,
  hideErrorMessage: false,
  LabelProps: null,
  InputProps: null,
};
